// extracted by mini-css-extract-plugin
module.exports = {"container":"NsTabs_container_Wutm4","tabsBar":"NsTabs_tabsBar_38UrP","sliderWrapper":"NsTabs_sliderWrapper_8nD_g","slider":"NsTabs_slider_2ZXKw"};